/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'

const SLACondition = ({
  update,
  predicates: {
    within_sla: inSLA,
    sla_timeframe: time
  }
}) => {
  const inSLAOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]

  const timeOptions = [
    { label: 'One off', value: '0' },
    { label: '10 minutes', value: '10' },
    { label: '20 minutes', value: '20' },
    { label: '30 minutes', value: '30' },
    { label: '40 minutes', value: '40' },
    { label: '50 minutes', value: '50' },
    { label: '1 hour', value: '60' },
    { label: '1 hour, 10 minutes', value: '70' },
    { label: '1 hour, 20 minutes', value: '80' },
    { label: '1 hour, 30 minutes', value: '90' },
    { label: '1 hour, 40 minutes', value: '100' },
    { label: '1 hour, 50 minutes', value: '110' },
    { label: '2 hours', value: '120' }
  ]

  return (
    <>
      <FormInput label="In SLA?">
        <Select
          options={inSLAOptions}
          value={inSLA}
          onChange={e => update('within_sla', e.value)}
        />
      </FormInput>

      {inSLA && (
        <FormInput label="Time">
          <Select
            options={timeOptions}
            value={time}
            onChange={e => update('sla_timeframe', e.value)}
          />
        </FormInput>
      )}
    </>
  )
}

export default SLACondition
